import { createReducer, on } from '@ngrx/store';
import { IFlatInvestigator } from '@app/admin/admin.component';
import { defaultEntityState } from '@core/state/entities/entity';
import { authApiActions } from '@core/auth/auth.actions';
import { schema } from 'normalizr';
import { entityKey } from '@core/state/entities/entity-name-map';
import { mergeEntityState } from '@core/state/entities/entity.helpers';

export const adminInvestigatorSchema = new schema.Entity(
  entityKey.adminInvestigators
);
export const adminInvestigatorReducer = createReducer(
  defaultEntityState<IFlatInvestigator>(),
  on(authApiActions.investigatorsLoaded, (state, props) =>
    mergeEntityState(entityKey.adminInvestigators, state, props)
  )
);
